import { render, staticRenderFns } from "./InfantClubContent.vue?vue&type=template&id=482c5bbe&scoped=true"
import script from "./InfantClubContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfantClubContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InfantClubContent.vue?vue&type=style&index=0&id=482c5bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c5bbe",
  null
  
)

export default component.exports